// @ts-check

import { getAccountingPeriods, getVatPeriods } from '@/api/reports'

export const initReportState = () => ({
  vatPeriods: null,
  accountingPeriods: null
})

/**
 * @type {ReportGetterTree}
 */
export const reportGetters = {
  accountingPeriods: ({ accountingPeriods }) => accountingPeriods ?? [],
  vatPeriods: ({ vatPeriods }) => vatPeriods ?? []
}

/**
 * @type {ReportActionTree}
 */
export const reportActions = {
  getVatPeriods: async ({ state, commit }) => {
    if (state.vatPeriods) {
      return
    }
    const { data: vatPeriods } = await getVatPeriods()
    commit('setVatPeriods', vatPeriods)
  },
  getAccountingPeriods: async ({ state, commit }) => {
    if (state.accountingPeriods) {
      return
    }
    const accountingPeriods = await getAccountingPeriods()
    commit('setAccountingPeriods', accountingPeriods)
  }
}

/**
 * @type {ReportMutationTree}
 */
export const reportMutations = {
  setAccountingPeriods: (state, accountingPeriods) => {
    state.accountingPeriods = accountingPeriods
  },
  setVatPeriods: (state, vatPeriods) => {
    state.vatPeriods = vatPeriods
  },
  clearAllData: (state) => {
    state.vatPeriods = null
    state.accountingPeriods = null
  }
}

export const reportModule = {
  namespaced: true,
  state: initReportState,
  getters: reportGetters,
  mutations: reportMutations,
  actions: reportActions
}

export default reportModule
